var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _vm.success
            ? _c("div", { staticClass: "col-md-6 offset-md-3 my-5" }, [
                _c("div", { staticClass: "card border-0" }, [
                  _c("div", { staticClass: "card-body text-center py-5" }, [
                    _c("span", [
                      _c(
                        "svg",
                        {
                          attrs: {
                            viewBox: "0 0 24 24",
                            width: "56",
                            height: "56",
                            stroke: "#000",
                            "stroke-width": "1",
                            fill: "none",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" },
                          }),
                          _vm._v(" "),
                          _c("polyline", {
                            attrs: { points: "22 4 12 14.01 9 11.01" },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.isFree
                      ? _c("div", [
                          _c("h5", { staticClass: "mt-4 fw-bold" }, [
                            _vm._v(
                              _vm._s(_vm._f("translate")("Access granted"))
                            ),
                          ]),
                        ])
                      : _c("div", [
                          _c("h5", { staticClass: "mt-4 fw-bold" }, [
                            _vm._v(
                              _vm._s(_vm._f("translate")("Payment successful"))
                            ),
                          ]),
                        ]),
                    _vm._v(" "),
                    ["consultation"].includes(_vm.type)
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c("p", { staticClass: "lead m-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")("Please check your inbox")
                              ) + "."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "lead m-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")("An email is on the way")
                              ) + "."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "lead m-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Email contains further instructions"
                                )
                              ) + "."
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    ["physical"].includes(_vm.type)
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c("h5", { staticClass: "fw-bolder" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Thank you for placing your order"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-group mt-4 text-start" },
                            [
                              _c("li", { staticClass: "list-group-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "fw-semibold small" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("translate")("Order number")
                                        ) +
                                        ":\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v("#" + _vm._s(_vm.transaction.id)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "list-group-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "fw-semibold small" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm._f("translate")("Product")) +
                                        ":\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(_vm.transaction.product)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "list-group-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "fw-semibold small" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm._f("translate")("Paid")) +
                                        ":\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("amount")(
                                          _vm.transaction.amount,
                                          _vm.transaction.currency
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "list-group-item" }, [
                                _c(
                                  "div",
                                  { staticClass: "fw-semibold small" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("translate")(
                                            "Shipping address"
                                          )
                                        ) +
                                        ":\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _vm.transaction.shipping_data.shipmentType ===
                                  "parcel_locker"
                                    ? _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("translate")(
                                                "Parcel locker"
                                              )
                                            ) +
                                              " : " +
                                              _vm._s(
                                                _vm.transaction.shipping_data
                                                  .parcelLockerCode
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.transaction.shipping_data.shipmentType ===
                                  "courier"
                                    ? _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.transaction.shipping_data
                                                .address
                                            ) +
                                              ", " +
                                              _vm._s(
                                                _vm.transaction.shipping_data
                                                  .postalCode
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.transaction.shipping_data
                                                  .city
                                              )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !["physical"].includes(_vm.type)
                      ? _c(
                          "a",
                          {
                            staticClass: "btn px-4 mt-4",
                            class: {
                              "btn-dark": [
                                "course",
                                "bundle",
                                "membership",
                                "live",
                                "file",
                              ].includes(_vm.type),
                              "btn-outline-dark": ["consultation"].includes(
                                _vm.type
                              ),
                            },
                            attrs: { href: _vm.redirect },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.successCTA) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "col-md-6 offset-md-3 my-5" }, [
                !_vm.error
                  ? _c("div", { staticClass: "card border-0" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "text-center" }, [
                          _c("div", {
                            staticClass: "spinner-border ms-3",
                            attrs: { role: "status", "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _c("h5", { staticClass: "mt-4 fw-bold" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("translate")(
                                    "Transaction processing..."
                                  )
                                ) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.warning
                            ? _c("div", { staticClass: "mt-5" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "We haven't received a transaction confirmation yet."
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "Please check if the transaction registered in your bank account."
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "card border-0 bg-warning mt-3" },
                      [
                        _c("div", { staticClass: "card-body text-center" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Your payment did not go through"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-outline-primary",
                              attrs: { href: _vm.checkoutLink },
                            },
                            [_vm._v(_vm._s(_vm._f("translate")("Go back")))]
                          ),
                        ]),
                      ]
                    ),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.success ? _vm._t("default") : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }